import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "is-flex is-align-item-center is-justify-content-space-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Cronometro = _resolveComponent("Cronometro")!
  const _component_Botao = _resolveComponent("Botao")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_Cronometro, { tempoEmSegundos: _ctx.tempoEmSegundos }, null, 8, ["tempoEmSegundos"]),
    _createVNode(_component_Botao, {
      onClicado: _ctx.iniciar,
      icone: "fas fa-play",
      texto: "Play",
      desabilitado: _ctx.cronometroRodando
    }, null, 8, ["onClicado", "desabilitado"]),
    _createVNode(_component_Botao, {
      onClicado: _ctx.finalizar,
      icone: "fas fa-stop",
      texto: "Stop",
      desabilitado: !_ctx.cronometroRodando
    }, null, 8, ["onClicado", "desabilitado"])
  ]))
}